import axios from "@/axios";
import { PublishersResponse } from "@/commons/types";
import { AxiosResponse } from "axios";

export function getPublishers(): Promise<AxiosResponse<PublishersResponse>> {
  return axios.get<PublishersResponse>(`/publishers/`);
}
